/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react'
import { ModuleCard, InputIcon } from 'components/molecules'
import { Spacer } from 'components/atoms'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro';
import modules from 'modules'
import Fuse from 'fuse.js'

const ModuleSelect = ({
  onSelect,
  isAdmin,
}) => {
  const [search, setSearch] = React.useState('')
  const modulesSelectable = useMemo(() => {
    const modulesKeys = Object.keys(modules).filter(moduleKey => {
      const module = modules[moduleKey]
      if (moduleKey === 'SEO') return false
      if (moduleKey === 'Placeholder') return false
      if (moduleKey === 'Navigation') return false
      if (!isAdmin && module.options.adminOnly) return false
      return !module.options.hidden
    })
    return modulesKeys.map(key => ({
      key,
      ...modules[key]
    }))
  }, [isAdmin])

  const fuse = useMemo(() => new Fuse(modulesSelectable, {
    threshold: 0.2,
    keys: [
      {
        name: 'key',
        weight: 0.01,
      },
      {
        name: 'options.label',
        weight: 0.84,
      },
      {
        name: 'options.description',
        weight: 0.05,
      },
      {
        name: 'options.tags',
        weight: 0.1,
      }
    ]
  }), [modulesSelectable])

  const modulesFiltered = useMemo(() => {
    if (search === '') return modulesSelectable
    return fuse.search(search).map(({ item }) => item)
  }, [search, fuse])

  return (
    <>
      <Spacer bottom="m">
        <InputIcon
          icon="search"
          placeholder="pesquisar módulos"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          modifiers={['stretch']}
        />
      </Spacer>
      <List>
        {modulesFiltered.map(module => (
          <ModuleCard
            key={module && module.key ? module.key : null}
            label={module && module.options && module.options.label ? module.options.label : null}
            description={
              module && module.options && module.options.description
                ? module.options.description
                : null
            }
            thumbnail={
              module && module.options && module.options.thumbnail
                ? module.options.thumbnail
                : null
            }
            onClick={() => onSelect(module)}
          />
        ))}
      </List>
    </>
  )
}

const List = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: ${props => props.theme.spacing.xs};
`

ModuleSelect.defaultProps = {
  onSelect: () => { },
  isAdmin: false,
}

ModuleSelect.propTypes = {
  onSelect: PropTypes.func,
  isAdmin: PropTypes.bool,
}


export default ModuleSelect
